import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconQRCode = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconQRCode.dimensions.width} ${IconQRCode.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="M7.5 4.5v3h-3v-3h3ZM9 3H3v6h6V3Zm-1.5 9.5v3h-3v-3h3ZM9 11H3v6h6v-6Zm6.5-6.5v3h-3v-3h3ZM17 3h-6v6h6V3Zm-6 8h1.5v1.5H11V11Zm1.5 1.5H14V14h-1.5v-1.5ZM14 11h1.5v1.5H14V11Zm-3 3h1.5v1.5H11V14Zm1.5 1.5H14V17h-1.5v-1.5ZM14 14h1.5v1.5H14V14Zm1.5-1.5H17V14h-1.5v-1.5Zm0 3H17V17h-1.5v-1.5ZM20 5h-2V2h-3V0h5v5Zm0 15v-5h-2v3h-3v2h5ZM0 20h5v-2H2v-3H0v5ZM0 0v5h2V2h3V0H0Z"
        fill={color || Color.premiumBlack}
      />
    </Svg>
  )
}

IconQRCode.dimensions = {
  width: 20,
  height: 20,
}

export default IconQRCode
